import * as styles from './FileDropZoneImage.css';

export const FileDropZoneImage = () => {
  return <div className={styles['container']} />;
};
